<script>
import moment from 'moment';

export default {
    data() {
        return {
            vueModelErrorList: ''
        };
    },
    mounted() {
        if (this.vueModel !== undefined) {
            this.isModelValid(this.vueModel);
        }
    },
    methods: {
        isModelValid(model) {
            this.validatePropsRecursively(model);

            if (this.vueModelErrorList === '') {
                return true;
            }

            window.Utility.logError('Props failed in \'' + this.$options.name + '\': ' + this.vueModelErrorList.substring(2), this);

            return false;
        },
        validatePropsRecursively(model) {
            var propType = null;

            for (var prop in model) {
                propType = typeof model[prop];

                // Skip momentjs objects that contain an internal undefined property, we don't want dirtying the log
                if (moment.isMoment(model[prop])) {
                    continue;
                }

                if (model[prop] === undefined) {
                    this.vueModelErrorList += ', ' + prop;
                }

                if (propType === 'object') {
                    this.validatePropsRecursively(model[prop]);
                }
            }
        }
    }
};
</script>
